jQuery(function($)
{
    var
        { map } = orion,
        STREET = 'street',
        COUNTRYCODE = 'countryCode',
        META_SUFFIX_STREET_FEEDBACK_INVALID = '_' + STREET + '_feedback_invalid',
        META_SUFFIX_STREET_FEEDBACK_MISSING = '_' + STREET + '_feedback_missing',
        META_SUFFIX_STREET_PATTERN = '_' + STREET + '_pattern',
        ATTRIBUTE_SUFFIX_STREET = '[' + STREET + ']',
        ATTRIBUTE_SUFFIX_COUNTRYCODE = '[' + COUNTRYCODE + ']',
        ATTR_PATTERN = 'pattern',
        TEXT_FEEDBACK_INVALID = '.feedback.invalid',
        TEXT_FEEDBACK_MISSING = '.feedback.missing',
        $street = $('[name$="' + ATTRIBUTE_SUFFIX_STREET + '"]'),
        $countryCode = $('[name$="' + ATTRIBUTE_SUFFIX_COUNTRYCODE + '"]'),
        metaName = {
            '.feedback.invalid': META_SUFFIX_STREET_FEEDBACK_INVALID,
            '.feedback.missing': META_SUFFIX_STREET_FEEDBACK_MISSING,
            'pattern': META_SUFFIX_STREET_PATTERN
        },
        metaElements = map(metaName, function(name)
        {
            return $('meta[name$="' + name + '"]');
        }),
        metaData = (function()
        {
            var i,
                metaData = {};

            for (i in metaElements)
            {
                if (Object.prototype.hasOwnProperty.call(metaElements, i))
                {
                    metaElements[i].each(function()
                    {
                        var
                            $meta = $(this),
                            countryCode = $meta.attr('name').slice(0, -metaName[i].length),
                            thisMetaData = {};

                        thisMetaData[countryCode] = {
                            'attr': {},
                            'text': {}
                        };
                        switch (i)
                        {
                        case ATTR_PATTERN:
                            thisMetaData[countryCode]['attr'][i] = $meta.attr('content');
                            break;
                        case TEXT_FEEDBACK_INVALID:
                        case TEXT_FEEDBACK_MISSING:
                            thisMetaData[countryCode]['text'][i] = $meta.attr('content');
                            break;
                        default:
                            break;
                        }

                        $.extend(true, metaData, thisMetaData);
                    });
                }
            }
            return metaData;
        })();

    function getTextNodesIn(node, includeWhitespaceNodes)
    {
        var textNodes = [],
            nonWhitespaceMatcher = /\S/;

        function getTextNodes(node)
        {
            if (node.nodeType == 3)
            {
                if (includeWhitespaceNodes || nonWhitespaceMatcher.test(node.nodeValue))
                {
                    textNodes.push(node);
                }
            }
            else
            {
                for (var i = 0, len = node.childNodes.length; i < len; ++i)
                {
                    getTextNodes(node.childNodes[i]);
                }
            }
        }

        getTextNodes(node);
        return textNodes;
    }

    function updateAttributes($el, metaData)
    {
        $el.attr(metaData);
    }

    function updateText($el, metaData)
    {
        var $parent = $el.parent();
        var selector;

        for (selector in metaData)
        {
            if (Object.prototype.hasOwnProperty.call(metaData, selector))
            {
                getTextNodesIn($parent.find(selector).get(0), false)[0].textContent = metaData[selector];
            }
        }
    }

    function delegateUpdates(o)
    {
        var
            $countryCode = $(this),
            countryCode = $countryCode.val(),
            $street = $countryCode.data('$street');

        if (!metaData[countryCode] || $street.data('addressType') == 'packstation')
        {
            return;
        }

        o = $.extend({}, { 'triggerValidationParametersChanged': false }, o);

        updateAttributes($street, metaData[countryCode].attr);
        updateText($street, metaData[countryCode].text);

        if (o.triggerValidationParametersChanged && $street.val().length !== 0)
        {
            $street.trigger(orion.constants.EventValidationParametersChanged);
        }
    }

    function handleChange()
    {
        delegateUpdates.apply(this, [{ 'triggerValidationParametersChanged': true }]);
    }

    function initialize()
    {
        $street.each(function()
        {
            var
                $street = $(this),
                groupName = $street.attr('name').slice(0, -ATTRIBUTE_SUFFIX_STREET.length),
                $countryCode = $('[name="' + groupName + '[' + COUNTRYCODE + ']"]');

            $street.data('$countryCode', $countryCode);
            $countryCode.data('$street', $street);
        });

        $countryCode.each(delegateUpdates);
    }

    initialize();
    $countryCode.filter('select').on('change', handleChange);
});
